import { z } from "zod";

export const EntregaObraClienteCadastroSchema = z.object({
    idEntregaObra: z.number().int().optional(),
    idCliente: z.number().int().positive().optional(),
    idCentroCusto: z.number().int().positive().optional(),
    idsChecklistEntrega: z.array(z.number().int().positive()),
    clienteCadastrado: z.coerce.boolean().optional().default(false),
    descCliente: z.string().optional(),
    tipoVistoriaCliente: z.boolean().optional(),
    tipoVistoriaConstrutora: z.boolean().optional(),
    localVistoria: z.string().optional(),
    status: z.number().optional()

});

export type EntregaObraClienteCadastroForm = z.infer<typeof EntregaObraClienteCadastroSchema>;

export const defaultEntregaObraClienteCadastroForm: Partial<EntregaObraClienteCadastroForm> = {
    idEntregaObra: undefined,
    idCliente: undefined,
    idCentroCusto: undefined,
    idsChecklistEntrega: [],
    clienteCadastrado: false,
    descCliente: undefined,
    tipoVistoriaCliente: false,
    tipoVistoriaConstrutora: false,
    localVistoria: undefined,
    status: 0,

};
